import { ECOMemberPassIntegrationGetters } from './partials/eco-member-pass'
import { ECOPortalIntegrationCaseStatsGetters } from './partials/eco-portal-case-stats'
import { ECOPortalIntegrationGetters } from './partials/eco-portal'
import { KioskIntegrationGetters } from './partials/kiosk'
import { OWRIntegrationGetters } from './partials/owr'
import { SignupIntegrationGetters } from './partials/signup'
import { TmetricGetters } from './partials/tmetric'

export const IntegrationGetters = {
  ...ECOMemberPassIntegrationGetters,
  ...ECOPortalIntegrationCaseStatsGetters,
  ...ECOPortalIntegrationGetters,
  ...KioskIntegrationGetters,
  ...OWRIntegrationGetters,
  ...SignupIntegrationGetters,
  ...TmetricGetters,
}
